<template>
  <div>
    <v-layout align-center justify-center>
    <v-flex xs12 sm4 md3>
    <v-layout>
    <img src="../assets/login_background.jpg" alt="" id="background">
    <v-layout column class="box">
      <img src="../assets/nxtagro.png" alt="" id="logo">
      <v-flex xs6>
        <div class="white elevation-2" style="border-radius:8px !important; background:rgba(255,255,255,0.5)!important;">
          <br>
          <div class="pl-4 pr-4 pt-2 pb-2 input-box">
            <v-text-field
              id="username"
              label="Email"
              type="text"
              v-model="email"
              single-line
              solo
              class="input_text"
            ></v-text-field>
            <br>
            <v-text-field
              id="password"
              label="Password"
              type="password"
              v-model="password"
              single-line
              solo
              class="input_text"
              v-on:keyup.13="login"
            ></v-text-field>
            <div class="err" v-html="error"/>
            <br>
            <br>
            <v-btn
              v-on:keyup.13="login"
              dark
              id="login-btn"
              class="light-green darken-1"

              @click='login'>
              Login
            </v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
    </v-layout>
    </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import { setTimeout } from 'timers';
export default {
  data () {
    return {
      email: '',
      password: '',
      error: null
    }
  },
  // mounted() {
  //   if (this.$store.state.isUserLoggedIn) {
  //     console.log("test")
  //     window.addEventListener('keyup', event => {
  //       if (event.keyCode === 13) { 
  //         this.login()
  //       }
  //     })
  //   }
  // },
  methods: {
    async login () {
      try {
        const response = await AuthenticationService.login({
          email: this.email,
          password: this.password
        })
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$router.push({
          name: 'Dashboard'
        })
      } catch(error) {
        this.error = error.response.data.error
      }
    }
  }
};
</script>

<style scoped>
  .box {
    padding: 20px;
    margin-top: 20% !important;
    position: relative;
    z-index: 99999 !important;
  }

  .input_text {
    border-radius: 6% !important;
    height: 55px !important;
  }

  .err {
    color: red;
    background-color: none;
    padding: 10px;
  }

  .column {
    margin: auto;
    width: 400px;
  }

  input {
    margin: auto !important;
    display: block !important;
    border: .1px solid black !important;
  }

  .input-box {
    margin-top: 22%;
  }

  #login-btn {
    width: 60%;
    border-radius: 8px;
    margin-top: -50px !important;
    margin-left: 20% !important;
  } 

  #background {
    position:absolute;
    opacity: .7;
    top:0px;
    left:0px;
    width: 100%;
    height: 100%;
    z-index: 88888 !important;
  }

  #logo {
    top: -250px;
    position: absolute !important;
    margin-left: 16% !important;
    width: 50% !important;
  }

  @media only screen and (max-width: 500px) {
    .box {
      margin-left: auto !important;
    }
    #logo {
      width: 60% !important;
    }
    .input-box {
      margin-top: 40%;
    }
  }
</style>
